import { TableColumnType } from '@ui';

type ColKey = TableColumnType['key'];

export const col = (
  key: ColKey,
  label: string,
  options?: {
    sortable?: boolean;
    minWidthClassName?: string;
  },
): TableColumnType => ({
  key,
  label,
  isSortable: options?.sortable ?? false,
  minWidthClassName: options?.minWidthClassName ?? 'min-w-40',
});

export const COMMON_COLUMN_PRESETS = {
  code: col('code', 'Code', { sortable: true, minWidthClassName: 'min-w-[87px]' }),
  timezone: col('timezone', 'Timezone', { sortable: true, minWidthClassName: 'min-w-[115px]' }),
  address: col('address', 'Address', { minWidthClassName: 'min-w-80' }),
  city: col('city', 'City', { sortable: true, minWidthClassName: 'min-w-40' }),
  state: col('state', 'State', { sortable: true, minWidthClassName: 'min-w-[90px]' }),
  postalCode: col('postalCode', 'Postal code', { minWidthClassName: 'min-w-[109px]' }),
  actions: col('actions', '', { minWidthClassName: 'min-w-11' }),
} as const;

export const ADDRESS_COLUMNS = [
  COMMON_COLUMN_PRESETS.address,
  COMMON_COLUMN_PRESETS.city,
  COMMON_COLUMN_PRESETS.state,
  COMMON_COLUMN_PRESETS.postalCode,
] as const;
